import { render, staticRenderFns } from "./examinationsComponent.vue?vue&type=template&id=1a9f93ae&scoped=true"
import script from "./examinationsComponent.vue?vue&type=script&lang=js"
export * from "./examinationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9f93ae",
  null
  
)

export default component.exports